import * as PropTypes from 'prop-types'

import { isServer } from '/javascripts/checks'

export const withAnimationFrame = () => (WrappedComponent) => {
  class AnimationFrame extends React.PureComponent {
    static displayName = `withAnimationFrame(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`

    listener = null
    rafId = null

    componentWillUnmount() {
      this.stopLoop()
    }

    startLoop = (listener) => {
      if (isServer) return

      if (!listener) {
        console.error('withRequestAnimationFrame: no listener passed')
        return
      }

      this.stopLoop()
      this.listener = listener
      this.rafId = window.requestAnimationFrame(this.tick)
    }

    stopLoop = () => {
      this.listener = null
      window.cancelAnimationFrame(this.rafId)
    }

    tick = () => {
      this.listener && this.listener()
      this.rafId = window.requestAnimationFrame(this.tick)
    }

    render() {
      const rafProps = {
        startRafLoop: this.startLoop,
        stopRafLoop: this.stopLoop
      }

      return <WrappedComponent {...this.props} {...rafProps}  />
    }
  }

  WrappedComponent.propTypes = {
    ...WrappedComponent.propTypes,
    startRafLoop: PropTypes.func.isRequired,
    stopRafLoop: PropTypes.func.isRequired
  }

  return AnimationFrame
}
